# import CompanyFragment from "../fragments/company.graphql"

query CompanyQuery($id: ID) {
  company(id: $id) {
    ...CompanyFragment
  }
}
